import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/fleet-management-dashboard/page.tsx");
